<template>
    <div v-show="isShow" :style="'min-height:'+height+'px'" :class="{'notice-container': true,noticeIndex: true, error: type === 'error', center: posType === 'center'}">
        <div>
            <i></i>
            <span>{{message}}</span>
        </div>
        <i v-show="!hideClose" @click="close" class="close"></i>
    </div>
</template>

<script>
export default {
    name: 'gNotice',
    props: {
        posType: {
            type: String,
            default: 'normal'
        },
        height: {
            type: [String, Number],
            default: 40
        },
        type: {
            type: String,
            default: 'error'
        },
        message: {
            type: String,
            default: 'Message'
        },
        hideClose: {
            type: [Boolean, String],
            default: false
        }
    },
    data() {
        return {
            isShow: true
        }
    },
    methods: {
        close() {
            this.isShow = false;
        }
    }
}
</script>

<style lang="less">
    .notice-container.noticeIndex {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-height: 40px;
        padding: 10px 20px;
        box-sizing: border-box;

        &.center {
            justify-content: center;
        }

        span {
            font-size: 14px;
            line-height: 22px;
            color: #666666;
            word-break: break-all;
        }

        &.error {
            background-color: #FFF0EF;

            &>div {
                display: flex;
                flex-direction: row;
                align-items: center;

                i {
                    display: block;
                    min-width: 14px;
                    min-height: 14px;
                    background-image: url('./assets/errIcon.png');
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: contain;
                    user-select: none;
                    margin-right: 8px;
                }
            }
        }

        .close {
            display: block;
            width: 14px;
            height: 14px;
            background-image: url('./assets/delIcon.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
            user-select: none;
            cursor: pointer;
            margin-left: 10px;
        }
    }
</style>